import { useStore } from 'stores/Store';
import { useLazyQuery } from '@apollo/client';
import { QUERY_GET_QUESTIONNAIRES_BY_ENTITY_ID } from 'services/aws/session-query';
import { TestSetV2Type } from 'constants';
import { parseTestSessionDataToModel } from 'models/Entity';

const useQuestionnaires = ({ entityId }) => {
  const setQuestionnaires = useStore(state => state.setQuestionnaires);
  const [getQuestionnaires, { loading, error }] = useLazyQuery(
    QUERY_GET_QUESTIONNAIRES_BY_ENTITY_ID,
    {
      variables: { entityId, recurring: true }
    }
  );

  const parseQuestionnairData = questionnairesData => {
    if (questionnairesData?.getTestSessions) {
      const filteredQuestionnaires = questionnairesData.getTestSessions.filter(
        q => q.type !== TestSetV2Type.PREVENTION_TEMPLATE
      );
      const questionnaires = parseTestSessionDataToModel(
        filteredQuestionnaires.filter(s => s.recurring)
      );
      return [...questionnaires];
    }
    return [];
  };

  const fetchQuestionnaires = async () => {
    const { data: questionnairesData } = await getQuestionnaires();
    const questionnaires = parseQuestionnairData(questionnairesData);
    setQuestionnaires(questionnaires);
    return !!questionnaires.length;
  };

  return {
    loading,
    error,
    fetchQuestionnaires
  };
};

export default useQuestionnaires;
